export default "__VITE_PUBLIC_ASSET__333f92f2__"